import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useSuperIntl } from "../_";
import { useMount } from 'ahooks';
import { Axis, Chart, Coordinate, Interval, Legend, registerShape, Tooltip } from 'bizcharts';
import _ from 'lodash';
import React from 'react';
import { ResourceSummaryItem } from "./Item";
export var ResourceSummary = function ResourceSummary(properties) {
  var _properties$colors = properties.colors,
    colors = _properties$colors === void 0 ? ['rgb(87, 211, 68)', 'rgb(249, 57, 64)', 'rgb(219, 221, 224)', 'rgb(150, 152, 155)'] : _properties$colors;
  var intl = useSuperIntl();
  useMount(function () {
    registerShape('interval', 'sliceShape', {
      draw: function draw(cfg, container) {
        if (cfg.points) {
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              // @ts-expect-error
              path: this.parsePath([
              // @ts-expect-error
              ['M', cfg.points[0].x, cfg.points[0].y],
              // @ts-expect-error
              ['L', cfg.points[1].x, cfg.points[1].y - 0.025],
              // @ts-expect-error
              ['L', cfg.points[2].x, cfg.points[2].y - 0.025],
              // @ts-expect-error
              ['L', cfg.points[3].x, cfg.points[3].y], 'Z'])
            }
          });
        }
      }
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    height: 40,
    width: 40,
    autoFit: true,
    data: properties.datum
  }, /*#__PURE__*/React.createElement(Coordinate, {
    type: "theta",
    radius: 1,
    innerRadius: 0.6
  }), /*#__PURE__*/React.createElement(Axis, {
    visible: false
  }), /*#__PURE__*/React.createElement(Tooltip, {
    visible: false
  }), /*#__PURE__*/React.createElement(Interval, {
    adjust: "stack",
    position: properties.angleField,
    color: [properties.colorField, colors],
    shape: "sliceShape"
  }), /*#__PURE__*/React.createElement(Legend, {
    visible: false
  })), /*#__PURE__*/React.createElement(ResourceSummaryItem, _extends({
    data: _defineProperty(_defineProperty({}, properties.colorField, intl.formatMessage({
      id: 'Total'
    })), properties.angleField, _.sumBy(properties.datum, function (data) {
      return data[properties.angleField];
    }))
  }, properties)), properties.datum.map(function (data, index) {
    return /*#__PURE__*/React.createElement(ResourceSummaryItem, _extends({
      key: index,
      data: data,
      color: colors[index]
    }, properties));
  }));
};
ResourceSummary.Item = ResourceSummaryItem;